import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Nav from './nav/';
import SubNav from './subNav/';
import CityNav from './cityNav/';

class Navigation extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        turnRed: PropTypes.bool,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { nav, subNav, subNavArea, cityNav },
            turnRed,
        } = this.props;

        return (
            <React.Fragment>
                <nav className={`${turnRed ? styles.bgnone : styles.nav}`} aria-label="主导航">
                    <Chip id="50056" type="struct" title="主导航" groupName="导航栏" content={nav}>
                        <Nav />
                    </Chip>
                </nav>
                <NoSSR onSSR={<div className={styles.ssr_nav} />}>
                    <Chip id="50057" type="struct" title="副导航" groupName="导航栏" content={subNav}>
                        <SubNav subNavArea={subNavArea} />
                    </Chip>
                </NoSSR>
                <nav className={`${turnRed ? styles.smallLineBox : ''}`} aria-label="城市导航">
                    <Chip id="261078" type="struct" title="城市导航" groupName="导航栏" content={cityNav}>
                        <CityNav />
                    </Chip>
                </nav>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Navigation);
